<template>
  <div class="body">
    <img
      v-if="isWeixin"
      class="tip"
      :src="aliURL + '/h5/purchase/img/new/go-other.png'"
    >
  </div>
</template>

<script>
import { getWebEnv } from 'assets/tools.js';
import aliPay from 'assets/aliPay.js';
import OrderApi from 'api/OrderApi';
export default {
  data() {
    return {
      aliURL: 'https://sc2.hexiaoxiang.com',
      isWeixin: null,
      urlData: {},
      setInterval: null,
      redirect: null
    };
  },
  created() {
    this.urlData = this.$route.query;
    const { out_trade_no } = this.urlData;
    if (out_trade_no) {
      // this.getOrderType();
      this.init();
    }
  },
  beforeDestroy() {
    clearInterval(this.setInterval);
    this.setInterval = null;
  },
  methods: {
    init() {
      const {
        out_trade_no,
        title,
        productId,
        payMode,
        hbfq_num
      } = this.urlData;
      this.isWeixin = getWebEnv().isWeixin;
      // 在微信内
      if (!this.isWeixin) {
        const redirect = window.location.href.replace(
          /#\/.+$/,
          `#/paySuc?productId=${productId}&key=${this.$store.state.key}`
        );
        this.redirect = redirect;
        let data = {
          out_trade_no,
          subject: title,
          return_url: redirect
        };

        // @see https://confluence.hexiaoxiang.com/pages/viewpage.action?pageId=34900791
        if (payMode === 'hbfq') {
          data = {
            ...data,
            hb_fq_num: +hbfq_num,
            hb_fq_seller_percent: 0 // 用户承担手续费
          };
          aliPay.pay(data);
        } else {
          aliPay.pay(data);
        }
      }
      this.setInterval = window.setInterval(() => {
        this.getOrderType();
      }, 5000);
    },
    getOrderType() {
      OrderApi.checkOrderType({
        out_trade_no: this.$route.query.out_trade_no
      }).then(res => {
        if (res.data.trade_state === 1) {
          this.isWeixin = false;
          clearInterval(this.setInterval);
          this.$router.push(
            `/paySuc?productId=${this.urlData.productId}&key=${this.$store.state.key}`
          );
        }
      });
    }
  }
};
</script>

<style lang="scss">
.tip {
  margin: 4px 0 0 78px;
  width: 273px;
  height: 289px;
  opacity: 1;
}
</style>
